export default "__VITE_ASSET__DPmNdi_c__"